import { $themeConfig } from '@themeConfig'

export default {
  state: {
    connected: false,
    websocket: null,
    play: false,
    // инкремент-токен для сигнала календарю о необходимости обновить события
    calendarRefreshToken: 0,
    // типы уведомлений, которые должны триггерить перезагрузку календаря
    bookingTypes: ['booking_created', 'booking_updated', 'booking_cancelled', 'booking_payment_successful'],
    appTypes: ['mobile_app_purchase_completed', 'mobile_app_access_subscription_created', 'mobile_app_access_subscription_updated', 'mobile_app_access_subscription_cancelled', 'mobile_app_access_subscription_renewed']
  },
  getters: {
    getPlay(state) {
      return state.play
    },
    getCalendarRefreshToken(state) {
      return state.calendarRefreshToken
    },
  },
  mutations: {
    UPDATE_WEBSOCKET(state, data) {
      state.websocket = data
    },
    UPDATE_CONNECTED(state, data) {
      state.connected = data
    },
    UPDATE_PLAY(state) {
      state.play = !state.play
    },
    TRIGGER_CALENDAR_REFRESH(state) {
      state.calendarRefreshToken += 1
    },
  },
  actions: {
    async connect(context, user) {
      if (!context.state.connected) {
        let wsProtocol = 'wss://'
        if (window.location.protocol !== 'https:') {
          wsProtocol = 'ws://'
        }
        await context.commit('UPDATE_WEBSOCKET', new WebSocket(
          `${wsProtocol}${$themeConfig.app.backendHostname}/ws/notification/?${user}`,
        ))
        // eslint-disable-next-line no-param-reassign
        context.state.websocket.onopen = () => {
          context.commit('UPDATE_CONNECTED', true)
          // eslint-disable-next-line no-param-reassign
          context.state.websocket.onmessage = ({ data }) => {
            const notification = JSON.parse(data)
            console.log('NEW_NOTIFICATION', notification)
            // new booking — показать в колокольчике
            if (notification.notification_type === 'booking_created') {
              context.commit('updatePushNotifications', notification, { root: true })
            }
            // обновление календаря при любом изменении записей
            // TODO: когда бэкенд начнёт слать organization_id в notification.data —
            // фильтровать по текущей организации, чтобы не дёргать refetch зря
            if (context.state.bookingTypes.includes(notification.notification_type)) {
              context.commit('TRIGGER_CALENDAR_REFRESH')
            }
            // mobile app / subscriptions
            if (context.state.appTypes.includes(notification.notification_type)) {
              const orgId = context.rootState.organization.organizationSettings.id
              // context.dispatch('updateApplicationInfo', data, { root: true })
              context.dispatch('checkApplicationStatus', orgId, { root: true })
              context.dispatch('fetchOrganizationSettings', orgId, { root: true })
            }
            if (JSON.parse(localStorage.getItem('sound'))) {
              context.commit('UPDATE_PLAY')
            }
          }
        }
        // eslint-disable-next-line no-param-reassign
        context.state.websocket.onerror = () => {
          context.commit('UPDATE_CONNECTED', false)
        }
      }
    },
    disconnect(context) {
      context.commit('UPDATE_CONNECTED', false)
      context.state.websocket.close()
    },
  },
}
